import './aitest.css'
import React from 'react'
import { BuyTest } from '../aitest/BuyTest'
import AuthContext from "../../../contexts/AuthContext";
import AITestContext from '../../../contexts/AITestContext'
import StatusContext from '../../../contexts/StatusContext'
import { AlertDialog } from '../alertdialog/AlertDialog'
import { ConfirmDialog } from '../alertdialog/ConfirmDialog'
import { useState } from "react";

export const DisplayAllTests = ({ chat, clickHandler, setTemplateName, handleFocus, seqid, total }) => {
  const [openDialog, handleDisplay] = useState(false);
  const [openConfirmDialog, handleConfirmDisplay] = useState(false);
  const [dialogtext, setDialogText] = useState('');

  let {
    changeLanguage,
    setShowBuyTestDialog,
    setDialogStatus,
  } = React.useContext(StatusContext);

  let {
    boughtchatNames,
    handleBuyTest_Test,
    setBuyPrice,
    setBuyTestName,
    setBuyTestCreatorId,
    setBuyTestChatAuthorKey,
    setCreatorName,
    displayChat,
    collegetestmode
  } = React.useContext(AITestContext);

  let {
    currentUser,
  } = React.useContext(AuthContext);

  const handleDisplayTest = (chat) => {
    clickHandler(chat)
    handleFocus()
  }

  const closeDialogBox = () => {
    handleDisplay(false);
  };

 
  const closeConfirmDialogBox = () => {
    handleConfirmDisplay(false);
  };

  const openConfirmDialogBox = () => {
    handleConfirmDisplay(true);
  }


  const handleOnClickBuyTest = () => {
    console.log("handleOnClickBuyTest-Creatorid: CurrentUser:", chat.creator_id, currentUser)
    console.log("Chat:", chat)

    //check if test already exists in the list of favourite tests
    let exists = false
    boughtchatNames.forEach((test) => {
      if (test.chatname === chat.chatname) {
        exists = true
        return;
      }
    })

    if (exists) {
      setDialogText("'" + chat.chatname + "'" + changeLanguage('aitest', 'testexists'))
      openConfirmDialogBox()
    }
    else {
      let price = parseFloat(chat.price).toFixed(2)
      setBuyPrice(price)
     
      if (price > 0) {
        setDialogStatus('')
        setShowBuyTestDialog(true)
        setBuyTestName(chat.chatname)
        setCreatorName(chat.creator_name)
        setBuyPrice(price)
        setBuyTestCreatorId(chat.creator_id)
        setBuyTestChatAuthorKey(chat.chatauthorkey)
        
        sessionStorage.setItem('buytest', JSON.stringify(chat))
      }
      else {
       
        displayChat(chat)
      }
    }
  }

  const handleBuyTest = (chat) => {
    console.log("handleBuyTest:", chat.chatname)

    let price = parseFloat(chat.price).toFixed(2)
    console.log("handleBuyTest:", chat.chatname, price)
    setBuyPrice(price)

    if (price > 0) {
      let buyteststatus = {
        chat: chat,
        status: true
      }
      sessionStorage.setItem('buyteststatus', JSON.stringify(buyteststatus))
      window.open(`/checkoutsession/${chat.creator_id}/${price}/${chat.chatname}`, '_blank');

    }
    else
      handleBuyTest_Test(chat)
  }

  const alertYesBuy = () => {
    closeDialogBox()
    handleBuyTest(chat)
  }

  const alertCancelBuy = () => {
    closeDialogBox()
  }

  const confirmYes = () => {
    closeConfirmDialogBox()
  }

  return (
    <div className="displayAllTestsRow" key={chat.id}>
   

      <div
        key={chat.id}
        className="displayTestName"
        onClick={() => { handleDisplayTest(chat); setTemplateName(chat.chatname) }}>

         <span style={{fontSize:'14px', fontWeight:'bold',paddingRight:'10px'}}>{`${seqid}/${total}`}:</span>{chat.chatname}
        
        {
          !collegetestmode &&
          <>
            <div className="aitestByAuthor">
              {changeLanguage('aitest', 'by')} {chat.creator_name}
            </div>
        
            <div className="aitestByAuthor">
                {changeLanguage('aitest', 'testarea')}{chat.subarea}
            </div>
            
            <div className="aitestByAuthor">
                {changeLanguage('aitest', 'testlanguage')}{chat.language}
            </div>
         </>
          }
          <br/>
       
      </div>
    {
      !collegetestmode &&
      <BuyTest price={chat.price} handleBuy={handleOnClickBuyTest} />
    }
    <br/>
    <br/>

      <AlertDialog alertYes={alertYesBuy} alertCancel={alertCancelBuy} openDialog={openDialog} closeDialog={closeDialogBox} prompt={dialogtext} />
      <ConfirmDialog alertYes={confirmYes} openDialog={openConfirmDialog} closeDialog={closeConfirmDialogBox} prompt={dialogtext} />
    </div>
  )
}